export function ConvertMillimetersToCentimeters(valueInMillimeters) {
  return typeof valueInMillimeters === 'number' ? valueInMillimeters / 10 : null;
}
export function ConvertCentimetersToMillimeters(valueInCentimeters) {
  return typeof valueInCentimeters === 'number' ? valueInCentimeters * 10 : null;
}
export function ConvertMillimetersToMeters(valueInMillimeters) {
  return typeof valueInMillimeters === 'number' ? valueInMillimeters / 1000 : null;
}
export function ConvertMetersToMillimeters(valueInCentimeters) {
  return typeof valueInCentimeters === 'number' ? valueInCentimeters * 1000 : null;
}
export function ConvertGramsToKiloGrams(valueInGrams) {
  return typeof valueInGrams === 'number' ? valueInGrams / 1000 : null;
}
export function ConvertKiloGramsToGrams(valueInKiloGrams) {
  return typeof valueInKiloGrams === 'number' ? valueInKiloGrams * 1000 : null;
}
